import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { ButtonVariant } from './ButtonVariant';
import { ButtonColor } from './ButtonColor';
import { ButtonSize } from './ButtonSize';
import { twMerge } from 'tailwind-merge';
function mapBaseClasses(variant, color) {
  const classes = ['focus:outline-hidden', 'focus-visible:ring', 'focus-visible:ring-black/20', 'disabled:text-gray-500', 'font-semibold', 'border-2', 'border-transparent', 'border-solid', 'transition-colors', 'hover:no-underline'];

  // variant check
  const isContained = variant === ButtonVariant.Contained;
  const isOutlined = variant === ButtonVariant.Outlined;

  // color check
  const isPrimary = color === ButtonColor.Primary;
  const isSecondary = color === ButtonColor.Secondary;
  const isLight = color === ButtonColor.Light;
  const isPill = color === ButtonColor.Pill;
  if (isContained) {
    classes.push('disabled:bg-gray-200');
    if (isPrimary) {
      classes.push('hover:bg-yellow-600', 'focus:bg-yellow-600', 'bg-yellow-500', 'text-black');
    }
    if (isSecondary) {
      classes.push('hover:bg-gray-900', 'focus:bg-gray-900', 'text-white', 'bg-black');
    }
    if (isLight) {
      classes.push('hover:bg-gray-200', 'focus:bg-gray-200', 'text-black', 'bg-white');
    }
    if (isPill) {
      classes.push('hover:bg-white', 'focus:bg-white', 'hover:border-black', 'text-black', 'bg-gray-200');
    }
  }
  if (isOutlined) {
    classes.push('disabled:border-gray-200');
    if (isPrimary) {
      classes.push('hover:text-black', 'hover:bg-yellow-500', 'focus:text-black', 'focus:bg-yellow-500', 'text-yellow-500', 'border-yellow-500');
    }
    if (isSecondary) {
      classes.push('hover:text-white', 'hover:bg-black', 'focus:text-white', 'focus:bg-black', 'text-black', 'border-black');
    }
    if (isLight) {
      classes.push('hover:text-black', 'hover:bg-white', 'focus:text-black', 'focus:bg-white', 'text-white', 'border-white');
    }
    if (isPill) {
      classes.push('hover:bg-gray-200', 'text-black', 'border-black');
    }
  }

  // focus ring color
  if (isPrimary) {
    classes.push('focus-visible:ring-yellow-500');
  }
  if (isSecondary) {
    classes.push('focus-visible:ring-gray-500');
  }
  if (isLight) {
    classes.push('focus-visible:ring-white');
  }
  if (isPill) {
    classes.push('focus-visible:ring-gray-200');
  }
  return classes;
}
function mapSizeClasses(size) {
  if (size === ButtonSize.Small) {
    return 'px-8 py-1.5 text-sm leading-4';
  }
  if (size === ButtonSize.Large) {
    return 'py-2.5 px-16 leading-6';
  }
  return 'px-8 py-1.5 leading-6';
}
export default /*#__PURE__*/forwardRef(function Button(props, ref) {
  const {
    className,
    color = ButtonColor.Primary,
    fullWidth = false,
    size = ButtonSize.Medium,
    squared = false,
    variant = ButtonVariant.Contained,
    children,
    ...rest
  } = props;
  const classes = twMerge(...mapBaseClasses(variant, color), mapSizeClasses(size), squared ? 'rounded' : 'rounded-full', fullWidth && 'block w-full', className);
  if (props.href) {
    return /*#__PURE__*/React.createElement("a", _extends({}, rest, {
      ref: ref,
      className: classes
    }), children);
  }
  return /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    ref: ref,
    className: classes
  }), children);
});